import { createEffect, createStore, createEvent} from 'effector';

export const $faqData = createStore({});
export const getFaqEvent = createEvent();
export const getFaqFx = createEffect()

export const $openedItem = createStore('');
export const toggleItem = createEvent();
